import * as fb from "../../firebase";
import moment from "moment";
import axios from "axios";

export async function authenticateStrapiUser(username, password) {
  try {
    const response = await axios.post(
      "https://cms.wnm.arsconnect.com/auth/local",
      {
        identifier: username,
        password,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Check the response status
    if (response.status !== 200) {
      throw new Error("Strapi Authentication failed");
    }

    // Get the data directly from the response
    const jwtToken = response.data.jwt;

    // Optionally, you can commit a mutation to store the JWT token
    // commit('setToken', jwtToken);

    return jwtToken; // Return the token directly
  } catch (error) {
    console.error(
      "Strapi Authentication error:",
      (error.response && error.response.data) || error.message
    );
    throw error; // Re-throw the error for handling in the component
  }
}

export default {
  state: {
    selectKioskAnalytics: "",
    selectedDuration: "Today",
    todayBarChart: [
      { category: "8 AM", value: 0 },
      { category: "9 AM", value: 0 },
      { category: "10 AM", value: 0 },
      { category: "11 AM", value: 0 },
      { category: "12 PM", value: 0 },
      { category: "1 PM", value: 0 },
      { category: "2 PM", value: 0 },
      { category: "3 PM", value: 0 },
      { category: "4 PM", value: 0 },
      { category: "5 PM", value: 0 },
    ],
    pieChart: [
      { label: "Faqs", value: 0 },
      { label: "Maps", value: 0 },
      { label: "Forms", value: 0 },
      // { label: 'Payments', value: 0 },
      // { label: 'Hearings', value: 0 },
    ],
    languageBarChart: [
      { category: "English", value: 0 },
      { category: "Spanish", value: 0 },
    ],
    summaryBarChart: [],
    pieChartTotal: 0,
    paymentPieChartTotal: 0,
    singleDatePicker: false,
    selectedSingleDate: null,
    weekDatePicker: false,
    selectedWeekDate: null,
    fiscalYearPicker: false,
    enteredFiscalYear: "",
    closeWithoutSelection: 0,
    displayDate: "",
  },
  getters: {
    selectKioskAnalytics: (state) => state.selectKioskAnalytics,
    todayBarChart: (state) => state.todayBarChart,
    pieChart: (state) => state.pieChart,
    paymentPieChart: (state) => state.paymentPieChart,
    getPieChartTotal: (state) => state.pieChartTotal,
    getPaymentPieChartTotal: (state) => state.paymentPieChartTotal,
    languageBarChart: (state) => state.languageBarChart,
    summaryBarChart: (state) => state.summaryBarChart,
    selectedDuration: (state) => state.selectedDuration,
    singleDatePicker: (state) => state.singleDatePicker,
    selectedSingleDate: (state) => state.selectedSingleDate,
    weekDatePicker: (state) => state.weekDatePicker,
    selectedWeekDate: (state) => state.selectedWeekDate,
    displayDate: (state) => state.displayDate,
    fiscalYearPicker: (state) => state.fiscalYearPicker,
    enteredFiscalYear: (state) => state.enteredFiscalYear,
    closeWithoutSelection: (state) => state.closeWithoutSelection,
  },
  mutations: {
    setSelectKioskAnalytics(state, kioskid) {
      state.selectKioskAnalytics = kioskid;
    },
    setSelectedDuration(state, duration) {
      state.selectedDuration = duration;
    },
    setPieChartTotal(state, total) {
      state.pieChartTotal = total;
    },
    setPaymentPieChartTotal(state, total) {
      state.paymentPieChartTotal = total;
    },
    setSummaryBarChart(state, summary) {
      state.summaryBarChart.push(summary);
    },
    clearSummaryBarChart(state) {
      state.summaryBarChart = [];
    },
    setSingleDatePicker(state, status) {
      state.singleDatePicker = status;
    },
    setSelectedSingleDate(state, date) {
      state.selectedSingleDate = date;
    },
    setWeekDatePicker(state, status) {
      state.weekDatePicker = status;
    },
    setSelectedWeekDate(state, dates) {
      state.selectedWeekDate = dates;
    },
    setDisplayDate(state, dateString) {
      console.log(dateString,"This is display date");
      state.displayDate = dateString;
    },
    setFiscalYearPicker(state, status) {
      state.fiscalYearPicker = status;
    },
    setEnteredFiscalYear(state, year) {
      state.enteredFiscalYear = year;
    },
    setcloseWithoutSelection(state, value) {
      state.closeWithoutSelection = value;
    },
    resetPieChart(state) {
      state.pieChart = [
        { label: "Faqs", value: 0 },
        { label: "Maps", value: 0 },
        { label: "Forms", value: 0 },
        { label: "Payments", value: 0 },
        { label: "Hearings", value: 0 },
        { label:"HSA",value:0},
        { label:"Jurisdiction",value:0}
        
      ];
    },
    resetPaymentPieChart(state) {
        state.paymentPieChart = [
          { label: "Initiated", value: 0 },
          { label: "Success", value: 0 },
          { label: "Cancelled", value: 0 },
        ];
      },
    resetLanguageBarChart(state) {
      state.languageBarChart = [
        { category: "English", value: 0 },
        { category: "Spanish", value: 0 },
      ];
    },
    resetTodayBarChart(state) {
      state.todayBarChart = [
        { category: "8 AM", value: 0 },
        { category: "9 AM", value: 0 },
        { category: "10 AM", value: 0 },
        { category: "11 AM", value: 0 },
        { category: "12 PM", value: 0 },
        { category: "1 PM", value: 0 },
        { category: "2 PM", value: 0 },
        { category: "3 PM", value: 0 },
        { category: "4 PM", value: 0 },
        { category: "5 PM", value: 0 },
      ];
    },
  },
  actions: {
    async getKioskAnalytics({ commit, getters, dispatch }, duration) {
        console.log(duration,"this is duration");
      let analyticsObj = {};
      let usersessionList = [];
      const today = new Date();
      let startDate, endDate;
      let startDateOld, endDateOld;
      if (duration.type === "Today") {
        today.setHours(0, 0, 0, 0);
        startDate = today.toISOString();
        const today1 = new Date();
        const tomorrow = new Date(today1);
        tomorrow.setDate(today1.getDate() + 1);
        endDate = tomorrow.toISOString();
        commit("setDisplayDate", moment(startDate).format("L"));
      } else if (duration.type === "Yesterday") {
        today.setHours(0, 0, 0, 0);
        endDate = today.toISOString();
        const tempDate = new Date();
        const yesterday = new Date(tempDate);
        yesterday.setDate(tempDate.getDate() - 1);
        yesterday.setHours(0, 0, 0, 0);
        startDate = yesterday.toISOString();
        console.log(moment(startDate).format("L"),"yesterday hai ye");
        commit("setDisplayDate", moment(startDate).format("L"));
      } else if (duration.type === "Select Date") {
        startDate = getters.selectedSingleDate.startDate.toISOString();
        endDate = getters.selectedSingleDate.endDate.toISOString();
        commit("setDisplayDate", moment(startDate).format("L"));
      } else if (duration.type === "This Week") {
        const weekToday = new Date();
        const currentDayOfWeek = weekToday.getDay();
        const startW = new Date(weekToday);
        startW.setDate(weekToday.getDate() - currentDayOfWeek);
        startW.setHours(0, 0, 0, 0);
        startDate = startW.toISOString();
        const endW = new Date(weekToday);
        endW.setDate(weekToday.getDate() + (6 - currentDayOfWeek));
        endW.setHours(0, 0, 0, 0);
        endDate = endW.toISOString();
        commit(
          "setDisplayDate",
          moment(startDate).format("L") + " - " + moment(endDate).format("L")
        );
      } else if (duration.type === "Select Week") {
        startDate = getters.selectedWeekDate.startDate.toISOString();
        endDate = getters.selectedWeekDate.endDate.toISOString();
        commit(
          "setDisplayDate",
          moment(startDate).format("L") + " - " + moment(endDate).format("L")
        );

        // year change
      } else if (duration.type === '2025') {
        const annualToday = new Date();
        const oneYearAgo = new Date(annualToday);
        oneYearAgo.setFullYear(annualToday.getFullYear() - 1);
        startDateOld = oneYearAgo.toISOString();
        endDateOld = annualToday.toISOString();
        const year = new Date().getFullYear();
        startDate = `${year}-01-01T00:00:00.000Z`;
        endDate = `${year}-12-31T23:59:59.999Z`;
        console.log(startDate,endDate,'check this? ');
        commit("setDisplayDate", "Annual " + annualToday.getFullYear());
      } else if (duration.type === "Fiscal Year") {
        startDate = getters.enteredFiscalYear.startDate.toISOString();
        endDate = getters.enteredFiscalYear.endDate.toISOString();
        commit(
          "setDisplayDate",
          moment(startDate).format("L") + " - " + moment(endDate).format("L")
        );
      } else if (duration.type === "All") {
        let sDate = new Date("2023-01-01");
        startDate = sDate.toISOString();

        const today = new Date();
        const formattedToday = today.toISOString().split('T')[0];
        // console.log(new Date(formattedToday),"Date i am giving"); 

        let eDate = new Date(formattedToday);
        // console.log(eDate,"date i need");
        endDate = eDate.toISOString();
        commit("setDisplayDate", "All Data");
      } else {
        console.log("Custom Duration");
      }
      console.log("Start Date: ", startDate);
      console.log("End Date: ", endDate);
      console.log("Kiosk Id: ", getters.selectKioskAnalytics);

      const jwtToken = await authenticateStrapiUser(
        "adminwnm",
        "1@#Backguard"
      );

      console.log(getters.selectKioskAnalytics," this is the selectKioskAnalytics");
      console.log(startDate,endDate," duration times");
      // console.log(`https://cms.wnm.arsconnect.com/user-sessions?applicationId=${getters.selectKioskAnalytics}&timeStamp_gte=${startDate}&timeStamp_lte=${endDate}&_limit=-1`,"this is the url");
      let config1 = {
        method: "get",
        maxBodyLength: Infinity,
        url: `https://cms.wnm.arsconnect.com/user-sessions?applicationId=${getters.selectKioskAnalytics}&timeStamp_gte=${startDate}&timeStamp_lte=${endDate}&_limit=-1`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      };
      console.log('This is URL:',config1.url);
    //   let config2 = {
    //     method: "get",
    //     maxBodyLength: Infinity,
    //     url: `https://cms.chester.arsconnect.com/qnas?kioskID=${getters.selectKioskAnalytics}&timeStamp_gte=${startDate}&timeStamp_lte=${endDate}&_limit=-1`,
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${jwtToken}`,
    //     },
    //   };
      axios
        .request(config1)
        .then((response) => {

          console.log("Response from Strapi_Check:",response.data);
          dispatch("transformSessions", response.data)
            .then((response) => {
              console.log("Response from Strapi after sending to transformSession: ", response);

              console.log("User Session List 1: ", usersessionList);
              console.log("User Sessions: ", response);
              usersessionList = response;
              analyticsObj = {
                userSessionAnalytics: usersessionList,
                totalUserSessions: usersessionList.length,
              };
              commit("setKioskAnalytics", analyticsObj);
              commit("resetTodayBarChart");
              commit("resetPieChart");
              commit("resetPaymentPieChart");
              commit("resetLanguageBarChart");
              if (Object.keys(usersessionList).length !== 0) {
                console.log(duration.type,"this is the one",usersessionList);
                if (duration.type === "Today") {
                  dispatch("createTodayBarChart", usersessionList);
                } else if (duration.type === "Yesterday") {
                  dispatch("createTodayBarChart", usersessionList);
                } else if (duration.type === "Select Date") {
                  dispatch("createTodayBarChart", usersessionList);
                }
                dispatch("createPieChart", usersessionList);
                // dispatch("createPaymentPieChart", response1.data);
                //dispatch("createLanguageBarChart", usersessionList);
              } else {
                //
              }
              // resolve('Kiosk analytical data fetched');
              return "Kiosk analytical data fetched";
            })
            .catch((error) => {
              // reject(error.message);
              throw new Error(error.message);
            });
        })
        .catch((error) => {
          // reject(error.message);
          throw new Error(error.message);
        });
      // resolve('Kiosk analytical data fetched');
      return "Kiosk analytical data fetched";
    },
    createTodayBarChart({ getters, commit }, usersessionList) {
      usersessionList.forEach((session) => {
        console.log("User Sessions at Daily Bar chart:", session);
        let day = moment(session.sessionEndTime).format("H");
        console.log("Time of the session: ", day);
        switch (day) {
          case "8":
            var eight = getters.todayBarChart.find(
              (item) => item.category === "8 AM"
            );
            eight.value = eight.value + 1;
            break;
          case "9":
            var nine = getters.todayBarChart.find(
              (item) => item.category === "9 AM"
            );
            nine.value = nine.value + 1;
            break;
          case "10":
            var ten = getters.todayBarChart.find(
              (item) => item.category === "10 AM"
            );
            ten.value = ten.value + 1;
            break;
          case "11":
            var eleven = getters.todayBarChart.find(
              (item) => item.category === "11 AM"
            );
            eleven.value = eleven.value + 1;
            break;
          case "12":
            var twelve = getters.todayBarChart.find(
              (item) => item.category === "12 PM"
            );
            twelve.value = twelve.value + 1;
            break;
          case "13":
            var thirteen = getters.todayBarChart.find(
              (item) => item.category === "1 PM"
            );
            thirteen.value = thirteen.value + 1;
            break;
          case "14":
            var fourteen = getters.todayBarChart.find(
              (item) => item.category === "2 PM"
            );
            fourteen.value = fourteen.value + 1;
            break;
          case "15":
            var fifteen = getters.todayBarChart.find(
              (item) => item.category === "3 PM"
            );
            fifteen.value = fifteen.value + 1;
            break;
          case "16":
            var sixteen = getters.todayBarChart.find(
              (item) => item.category === "4 PM"
            );
            sixteen.value = sixteen.value + 1;
            break;
          case "17":
            var seventeen = getters.todayBarChart.find(
              (item) => item.category === "5 PM"
            );
            seventeen.value = seventeen.value + 1;
            break;
        }
      });
    },
    createPieChart({ getters, commit }, usersessionList) {
      commit("resetPieChart");
      usersessionList.forEach((session) => {
        console.log("Sessions: ", session.userSession);
        // const data = JSON.parse(session.userSession);
        const data = session.sessionData;
        console.log(data,"This is the data for pie chart");
        var faq = getters.pieChart.find((item) => item.label === "Faqs");
        faq.value =
          faq.value + data.filter((item) => item.response === "faqs").length;

        var form = getters.pieChart.find((item) => item.label === "Forms");
        form.value =
          form.value + data.filter((item) => item.response === "forms").length;

        var map = getters.pieChart.find((item) => item.label === "Maps");
        map.value =
          map.value + data.filter((item) => item.response === "maps").length;

        var pay = getters.pieChart.find((item) => item.label === "Payments");
        pay.value =
          pay.value +
          data.filter((item) => item.response === "payments" || item.response === "Parole and Probation" || item.response === "Pay Traffic Ticket" || item.response === "Bail Payment").length;

        var hearing = getters.pieChart.find(
          (item) => item.label === "Hearings"
        );
        hearing.value =
          hearing.value +
          data.filter((item) => item.response === "todayshearing").length;

        var hsa = getters.pieChart.find(
          (item) => 
            // console.log(item,"This is item")
            item.label === "HSA"
        );
        hsa.value =
        hsa.value +
          data.filter((item) => item.response === "Human Services Assistance").length;


          // { label:"Jurisdiction",value:0}


          var jurisdiction = getters.pieChart.find(
            (item) => 
              // console.log(item,"This is item")
              item.label === "Jurisdiction"
          );
          jurisdiction.value =
          jurisdiction.value +
            data.filter((item) => item.response === "Locate Your Jurisdiction").length;
        
        commit(
          "setPieChartTotal",
          faq.value + form.value + map.value + pay.value + hearing.value + hsa.value + jurisdiction.value
        );
      });
    },
    createPaymentPieChart({ getters, commit }, paymentList) {
        commit("resetPaymentPieChart");
        var initiated = getters.paymentPieChart.find(
          (item) => item.label === "Initiated"
        );
        var success = getters.paymentPieChart.find(
          (item) => item.label === "Success"
        );
        var cancel = getters.paymentPieChart.find(
          (item) => item.label === "Cancelled"
        );
        initiated.value = paymentList.filter(
          (item) => item.paymentStatus === "INITIATED"
        ).length;
        success.value = paymentList.filter(
          (item) => item.paymentStatus === "SUCCESS"
        ).length;
        cancel.value = paymentList.filter(
          (item) => item.paymentStatus === "CANCELLED"
        ).length;
        commit(
          "setPaymentPieChartTotal",
          success.value + initiated.value + cancel.value
        );
      },
    createLanguageBarChart({ getters }, usersessionList) {
      usersessionList.forEach((session) => {
        const data = JSON.parse(session.userSession);
        var english = getters.languageBarChart.find(
          (item) => item.category === "English"
        );
        english.value = usersessionList.length;

        var spanish = getters.languageBarChart.find(
          (item) => item.category === "Spanish"
        );
        spanish.value =
          spanish.value +
          data.filter((item) => item.response === "Language changed to Spanish")
            .length;
      });
    },

    getKioskUtilizationSummary({ getters, commit, dispatch }) {
        commit("clearSummaryBarChart");
        const weekToday = new Date();
        const currentDayOfWeek = weekToday.getDay();
        const startW = new Date(weekToday);
        startW.setDate(weekToday.getDate() - currentDayOfWeek);
        let startDate = startW.toISOString();
        const endW = new Date(weekToday);
        endW.setDate(weekToday.getDate() + (6 - currentDayOfWeek));
        let endDate = endW.toISOString();
        let prodKioskList = [];
        //prodKioskList = getters.allRegisteredKiosks;
        getters.allRegisteredKiosks.forEach((kiosk) => {
          if (kiosk.data().env === "Prod" || kiosk.data().env === "Stage") {
            prodKioskList.push(kiosk);
          }
        });
        prodKioskList.sort((a, b) =>
          a.data().arsBrowserId.localeCompare(b.data().arsBrowserId)
        );
        prodKioskList.forEach( async (kiosk) => {
          commit(
            "setDisplayDate",
            moment(startDate).format("L") + " - " + moment(endDate).format("L")
          );

          const jwtToken = await authenticateStrapiUser(
            "adminwnm",
            "1@#Backguard"
          );
          
          let config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `https://cms.wnm.arsconnect.com/user-sessions?browserKioskId=${
              kiosk.data().arsBrowserId
            }&sessionStartTime_gte=${startDate}&sessionStartTime_lte=${endDate}&_limit=-1`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
          };
          axios.request(config).then((response) => {
            dispatch("transformSessions", response.data).then((response) => {
              let data1 = {
                id: kiosk.data().arsBrowserId,
                category: kiosk.data().name,
                value: response.length,
              };
              commit("setSummaryBarChart", data1);
            });
          });
        });
      },

      transformSessions({ commit }, sessions) {
        //console.log("Sessions: ", sessions);
        const sessionArray = [...sessions.values()];
        const grouped = sessionArray.reduce((acc, session) => {
          const { applicationSessionId } = session;
          if (!acc[applicationSessionId]) {
            acc[applicationSessionId] = [];
          }
          acc[applicationSessionId].push(session);
          return acc;
        }, {});
  
        const transformedData = Object.keys(grouped).map((sessionId) => {
          const group = grouped[sessionId];
          //let ended = group.filter(grp =>  grp.actionType === "Session Ended")
          if (group.length > 2) {
            console.log("What is in the group: ", group);
            return {
              applicationSessionId: group[0].applicationSessionId,
              applicationId: group[0].applicationId,
              startDate: group[0].timeStamp,
              endDate: group[group.length - 1].timeStamp,
              sessionData: group.map((item) => ({
                ...item.sessionPayload,
                actionType: item.actionType,
                applicationId: item.applicationId,
                applicationSessionId: item.applicationSessionId,
                timeStamp: item.timeStamp,
              })),
            };
          }
        });
        transformedData.forEach((data) => {
          if (data !== undefined) {
            data.sessionData.forEach((doc, i) => {
              if (doc.actionType === "Session Started") {
                const [element] = data.sessionData.splice(i, 1);
                data.sessionData.unshift(element);
              } else if (doc.actionType === "Session Ended") {
                console.log("Session Ended: ", doc);
                const index = data.sessionData.findIndex(
                  (obj) => obj.actionType === "Session Ended"
                );
                if (index !== -1) {
                  const [removedElement] = data.sessionData.splice(index, 1); // Removes the object
                  data.sessionData.push(removedElement);
                }
              }
            });
          }
        });
        return transformedData.filter((data) => data !== undefined);
      },
  },
};
